import React, { useContext } from 'react'
import './ProductDisplay.css'
import star_icon from '../Assets/star_icon.png'
import star_dull_icon from '../Assets/star_dull_icon.png';
import { ShopContext } from '../../Context/ShopContext';
const ProductDisplay = ({product}) => {
    const {add_to_cart}=useContext(ShopContext);
    
  return (
    <div className='productdisplay'>
        <div className="productdisplay-left">
            <div className="productdisplay-img-list">
                <img src={product.image}/>
                <img src={product.image}/>
                <img src={product.image}/>
                <img src={product.image}/>
            </div>
            <div className="productdisplay-img">
                <img className='productdisplay-main-img' src={product.image}/>                
            </div>
        </div>
        <div className="produtdisplay-right">
            <h1>{product.name}</h1>
            <div className="productdisplay-right-star">
                <img src={star_icon}/>
                <img src={star_icon}/>
                <img src={star_icon}/>
                <img src={star_icon}/>
                <img src={star_dull_icon}/>
                <p>(786)</p>
            </div>
            <div className="productdisplay-right-prices">
                <div className="productdisplay-right-price-old">${product.old_price}</div>
                <div className="productdisplay-right-price-new">${product.new_price}</div>
            </div>
            <div className="productdisplay-right-discription">
                I it good and trusted product. It has good popularity around the world and it is most selling product. there are some peaces of this product is in stock and the stock is about to end so please order emmidiatly. for more information you can contact with our customere care. we have policy that use first and then trust.
            </div>
            <div className="productdisplay-right-size">
                <h1>Select Size</h1>
                <div className="productdisplay-right-sizes">
                    <div>S</div>
                    <div>M</div>
                    <div>L</div>
                    <div>XL</div>
                    <div>XXL</div>
                </div>
                <button onClick={()=>{add_to_cart(product.id)}}>ADD TO CART</button>
                <div className="productdisplay-right-category"><span>Category :</span>Women , T-Shirt , Crop Top</div>
                <div className="productdisplay-right-category"><span>Tags :</span>Modern , Latest</div>
            </div>
        </div>
        
      

    </div>
  )
}

export default ProductDisplay
